module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAAXNSR0IArs4c6QAAAEVQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////Up1zwgAAABZ0Uk5TABAgMEBQX2BvcH+Aj5+gr7/P3+7v/jd+KKUAAAC5SURBVFjD7dfLDoIwEAXQvrDqWAql9v8/1dAWXQB9TDRxMXdL7okkl8RhjBKjjOvPbMTWvwdcnEx9HbDx6TfMaCDA2uf4fnArIAgggAACCCDgV4CVohrlCoBs+TNwKwCiBdAFQLUAYwHw1lRjaUh7gHk8MEUA8MAlAtxh+4+8DDH29Z4pC3zGJQZ9lLyZ6+HDgddHCx1fCAHfBfi0HSV55O8bBdqAwgEi2y6o0/7S+DIaTiLpPv3TvACsZdmvURllGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/web@2x.png
// module id = Wqhl
// module chunks = 1